import { styled } from '../../utils/styled'
import Grid from '../Grid'
import { Breadcrumbs, List } from '@mui/material'
import type { CSSObject } from '../theme/themeTypes'
import { Children } from 'react'

const StyledTopNavigation = styled(Grid)`
  padding: 16px 48px;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;

  h5 {
    max-width: 20ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  button {
    align-self: center;
  }
` as React.ComponentType<any>

const StyledNavActionSection = styled(Grid)`
  display: inline-flex;
  gap: 16px;
  flex-wrap: nowrap;
  flex-direction: row-reverse;
  align-items: center;
  .MuiIconButton-root {
    width: 40px;
    height: 40px;
    background: ${({ theme }) => theme.tokens.background.tonal.soft.default};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    :hover {
      background-color: ${({ theme }) => theme.tokens.background.main.pressed};
    }
    :active {
      background-color: ${({ theme }) => theme.tokens.background.tonal.soft.default};
    }
  }
` as React.ComponentType<any>

const StyledClientSection = styled(List)`
  padding: 0;
  .MuiListItemButton-root {
    padding: 0;
    margin-right: -8px;
    padding-right: 8px;
    padding-left: 16px;
    .MuiListItem-root {
      align-items: flex-start;
      flex-direction: row-reverse;
      align-items: center;
      text-align: right;
      padding: 0px;
      .MuiListItemAvatar-root {
        min-width: 0;
      }
      .MuiListItemText-root {
        margin-right: 16px;
        margin-top: 4px;
        margin-bottom: 4px;
        height: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        .MuiListItemText-primary {
          display: block;
        }
        .MuiListItemText-primary {
          line-height: 20px;
          color: ${({ theme }: any) => theme.tokens.foreground.main.primary};
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .MuiListItemText-secondary {
          display: block;
          margin-top: -2px;
          margin-bottom: 2px;
          line-height: 20px;
          color: ${({ theme }: any) => theme.tokens.foreground.main.secondary};
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
` as React.ComponentType<any>

export { StyledTopNavigation, StyledClientSection, StyledNavActionSection }

export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme, children }): CSSObject => {
  const breadcrumbCount = Children.count(children) ?? 0

  // 41px is the width of the separators, so need to subtract that from the total width before dividing
  // 24px is the gap between the left side of the nav and the right side, which we also need to subtract
  const breadcrumbItemMaxWidth = `calc((100% - 24px - (41px * ${breadcrumbCount - 1})) / ${breadcrumbCount})`
  return {
    display: 'inline-block',
    width: 'calc(100% - 88px)',
    '.MuiBreadcrumbs-separator': {
      color: theme.tokens.foreground.main.primary
    },
    ol: {
      display: 'flex',
      flexWrap: 'nowrap',
      height: '100%'
    },
    a: {
      color: theme.tokens.foreground.main.primary,
      textDecoration: 'none',
      fontFamily: theme.typography.h5.fontFamily,
      fontSize: theme.typography.body2.fontSize,
      ':hover': {
        borderBottom: `1px solid ${theme.tokens.foreground.main.primary}`
      }
    },
    '.MuiBreadcrumbs-li': {
      maxWidth: breadcrumbItemMaxWidth,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    h5: { color: theme.tokens.foreground.main.disabled, marginTop: '1px', maxWidth: 'unset' }
  }
})

export const StyledGridNavButtonsContainer = styled(Grid)(() => ({
  display: 'inline-block',
  'button:first-of-type': {
    marginRight: '8px'
  },
  flexWrap: 'nowrap'
}))
